import moment from "moment";
import React, { SyntheticEvent } from "react";

import { Format } from "../../../config/config";
import IFeedbackList from "../../../types/IFeedbackList";
import IMandant from "../../../types/IMandant";
import InitialSnackbarState from "../../../types/initialData/InitialSnackbarState";
import ISnackbarState from "../../../types/ISnackbarState";
import { deleteFeedbackRequest, loadFeedbackList, updateFeedbackRequest } from "../../../xhr/FeedbackRequests";

export const useFeedbackListing = (mandant: IMandant) => {
    const [feedbackList, setFeedbackList] = React.useState<IFeedbackList[]>([]);
    const [snackBarState, setSnackBarState] = React.useState<ISnackbarState>({
        ...InitialSnackbarState,
    });

    const closeSnackbar = () => {
        setSnackBarState({ isOpen: false, message: "", type: "success" });
    };

    const fetchFeedbackList = React.useCallback(() => {
        loadFeedbackList(mandant.key)
            .then((result: any) => {
                setFeedbackList(result.data);
                return Promise.resolve();
            })
            .catch(() => {
                setSnackBarState({
                    isOpen: true,
                    message: "Beim Laden der Anfragen ist ein Fehler aufgetreten",
                    type: "error",
                });
            });
    }, [mandant.key]);

    React.useEffect(() => {
        fetchFeedbackList();
    }, [fetchFeedbackList]);

    const actionMarkAsAswered = (event: SyntheticEvent<HTMLSpanElement>) => {
        const feedbackId: number = parseInt("" + event.currentTarget.dataset.id);

        const index = feedbackList.findIndex((search) => {
            return feedbackId === search.id;
        });

        updateFeedbackRequest(
            {
                dateAnswered: {
                    date: moment(new Date()).format(Format.dateTimeEn),
                },
                flagAnswered: true,
            },
            feedbackId,
            mandant.key
        )
            .then(() => {
                const updatedList = [...feedbackList];
                updatedList[index].answerDate = new Date().toString();
                updatedList[index].flagAnswered = true;
                setFeedbackList(updatedList);

                setSnackBarState({
                    isOpen: true,
                    message: "Die Nachricht wurde als beantwortet markiert",
                    type: "success",
                });
            })
            .catch(() => {
                setSnackBarState({
                    isOpen: true,
                    message: "Die Nachricht konnte nicht als beantwortet markiert werden",
                    type: "error",
                });
            });
    };

    const actionDeleteFeedback = (event: SyntheticEvent<HTMLSpanElement>) => {
        const feedbackId: number = parseInt("" + event.currentTarget.dataset.id);

        deleteFeedbackRequest(feedbackId, mandant.key)
            .then(() => {
                setSnackBarState({
                    isOpen: true,
                    message: "Die Anfrage wurde erfolgreich gelöscht",
                    type: "success",
                });

                fetchFeedbackList();
            })
            .catch(() => {
                setSnackBarState({
                    isOpen: true,
                    message: "Beim Löschen der Anfrage ist ein Fehler aufgetreten",
                    type: "error",
                });
            });
    };

    return {
        feedbackList,
        snackBarState,
        closeSnackbar,
        actionMarkAsAswered,
        actionDeleteFeedback,
    };
};
